import localForage from 'localforage';
import { WizardData } from '../types/wizard';

/**
 * Storage key for wizard draft data
 */
const DRAFT_KEY = 'dexcoQuotaWizardDraft';

/**
 * Configure localForage for better performance
 */
localForage.config({
  name: 'DexcoERP',
  storeName: 'wizardDrafts',
  description: 'Storage for wizard draft data'
});

/**
 * Save wizard draft data to IndexedDB
 * @param data - The wizard data to save
 * @returns Promise that resolves when save is complete
 */
export const saveDraft = async (data: WizardData): Promise<void> => {
  try {
    await localForage.setItem(DRAFT_KEY, data);
  } catch (error) {
    console.error('Failed to save draft:', error);
    throw new Error('Falha ao salvar rascunho');
  }
};

/**
 * Load wizard draft data from IndexedDB
 * @returns Promise that resolves to the saved draft data or null if none exists
 */
export const loadDraft = async (): Promise<WizardData | null> => {
  try {
    const draft = await localForage.getItem<WizardData>(DRAFT_KEY);
    return draft;
  } catch (error) {
    console.error('Failed to load draft:', error);
    return null;
  }
};

/**
 * Clear saved wizard draft from IndexedDB
 * @returns Promise that resolves when clear is complete
 */
export const clearDraft = async (): Promise<void> => {
  try {
    await localForage.removeItem(DRAFT_KEY);
  } catch (error) {
    console.error('Failed to clear draft:', error);
    throw new Error('Falha ao limpar rascunho');
  }
};

/**
 * Check if a draft exists in storage
 * @returns Promise that resolves to true if draft exists, false otherwise
 */
export const hasDraft = async (): Promise<boolean> => {
  try {
    const draft = await localForage.getItem(DRAFT_KEY);
    return draft !== null;
  } catch (error) {
    console.error('Failed to check for draft:', error);
    return false;
  }
}; 